import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchPortfolio, exportPortfolio} from '../../actions/portfolioActions';
import {
  PORTFOLIO_HEADERS,
  PORTFOLIO_VALUES,
  PORTFOLIO_VALUES_FOR_DATA_LABELS,
} from "../../constants/tableHeaders";
import utils from "../../lib/utils";
import {
  trackPageView,
  trackSearch,
  trackUserClick,
  trackUserInput,
  trackUserAttribute,
} from "@forwardfinancing/analytics-frontend-library";
import PortfolioFilter from "./PortfolioFilter";
import PipelinePortfolioBase from "../common/PipelinePortfolioBase/PipelinePortfolioBase";

const didInitiateSearch = (query) =>
  trackSearch({
    attribute: "Portfolio",
    data: {
      searchParam: query.q,
      startDate: query.start_date,
      endDate: query.end_date,
      sort: query.sort,
      order: query.order,
      portfolioStatuses: query.portfolio_statuses,
      programs: query.programs,
      type: query.type,
    },
    page: query.page,
  });
const didExport = () => {
  trackUserClick({ attribute: "export" });
  trackUserAttribute({ attribute: "export" });
};
const didSort = (query) =>
  trackUserInput({
    label: "Sort",
    Page: "portfolio",
    "Sort By": query.sort,
    Order: query.order,
  });

const delegate = { didInitiateSearch, didExport, didSort };

export class PortfolioPage extends React.Component {
  componentDidMount() {
    trackPageView("Portfolio");
  }

  render() {
    const tableInfo = {
      headers: PORTFOLIO_HEADERS,
      values: PORTFOLIO_VALUES,
      data: this.props.portfolio,
      totalPages: this.props.portfolioPagination.totalPages,
      currentPage: this.props.portfolioPagination.currentPage,
      dataLabels: PORTFOLIO_VALUES_FOR_DATA_LABELS,
      isSearchError: this.props.portfolioError,
      actionCellRenderer: (rowData) => utils.renewalEligibilityData(rowData),
      isAdmin: this.props.isAdmin,
      hasSpinner: this.props.hasSpinner,
    };

    return (
      <PipelinePortfolioBase
        headerText="Portfolio"
        fetchFilter={this.props.fetchFilter}
        exportFilter={this.props.exportFilter}
        delegate={delegate}
        FilterComponent={PortfolioFilter}
        tableInfo={tableInfo}
        selectedPartner={this.props.selectedPartner}
        hasSpinner={this.props.hasSpinner}
      />
    );
  }
}

// istanbul ignore next
function mapStateToProps(state){
  return {
    portfolio: state.portfolio,
    portfolioPagination: state.portfolioPagination,
    portfolioError: state.portfolioError,
    selectedPartner: state.partner.selected,
    isAdmin: state.user && utils.isAdmin(state.user.role),
    hasSpinner: true
  };
}

// istanbul ignore next
function mapDispatchToProps(dispatch){
  return {
    fetchFilter: bindActionCreators(fetchPortfolio, dispatch),
    exportFilter: bindActionCreators(exportPortfolio, dispatch)
  };
}

PortfolioPage.propTypes = {
  portfolio: PropTypes.array.isRequired,
  portfolioPagination: PropTypes.object.isRequired,
  portfolioError: PropTypes.bool.isRequired,
  selectedPartner: PropTypes.object,
  isAdmin: PropTypes.bool,
  fetchFilter: PropTypes.func.isRequired,
  exportFilter: PropTypes.func.isRequired,
  hasSpinner: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioPage);
